// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { Link } from "react-router-dom";
// import TripDetailsCard from "./TripDetailsCard";
// import { fetchAllvehicle, vehicleSelector } from "../api/vehicles";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchoneroute_details, routeSelector } from "../api/route";
// import { fetchpricingmodal, pricingSelector } from "../api/pricesetting";
// import axios from "axios";
// import { KeyUri } from "../key";

// const CarList = () => {
//   // Memoize retrievedData so it doesn't change on every render
//   const [retrievedData] = useState(() =>
//     JSON.parse(localStorage.getItem("Selected Data"))
//   );
//   const { all_vehicle } = useSelector(vehicleSelector);
//   const { current_route } = useSelector(routeSelector);
//   const { currentPricing } = useSelector(pricingSelector);
//   const dispatch = useDispatch();

//   const [tripdata, set_trip_data] = useState([]);
//   const [ride_date, set_ride_date] = useState();
//   const [activeTab, setActiveTab] = useState("shared");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
//   const [pricing_obj, setPricing_obj] = useState({});

//   // Run once on mount
//   useEffect(() => {
//     if (!retrievedData) return;
//     dispatch(fetchAllvehicle());
//     dispatch(fetchoneroute_details(retrievedData));
//     dispatch(fetchpricingmodal());
//     const formattedDate = new Date(retrievedData?.date).toISOString();
//     set_ride_date(formattedDate);
//   }, [dispatch, retrievedData]);

//   // Fetch trip data when ride_date changes
//   useEffect(() => {
//     if (!ride_date) return;
//     const fetchTrip = async () => {
//       try {
//         const response = await axios.post(
//           `${KeyUri.BACKEND_URI}/get-full-cabs`,
//           { rideDate: ride_date }
//         );
//         set_trip_data(response.data.details || []);
//       } catch (error) {
//         console.error("Error fetching trip:", error.response?.data || error.message);
//       }
//     };
//     fetchTrip();
//   }, [ride_date]);

//   // Update pricing object when currentPricing changes
//   useEffect(() => {
//     setPricing_obj(currentPricing?.[0] || {});
//   }, [currentPricing]);

//   // Memoize getprice to avoid recreation
//   const getprice = useCallback(
//     (car) => {
//       if (!car || !pricing_obj || !current_route) return 0;
//       console.log("here is the route details ", current_route)
//       if (pricing_obj.pricing_model === "Driver Fixed") {
//         const perSeat =
//           Number(car.price_per_trip?.$numberDecimal) / (car.capacity - 1);
//         return perSeat + perSeat * (pricing_obj.platform_price / 100);
//       }
//       if (pricing_obj.pricing_model === "Admin Fixed") {
//         const key =
//           car.category === "Economy"
//             ? "price_for_economy"
//             : car.category === "Luxury"
//               ? "price_for_luxary"
//               : "price_for_premium";
//         const base = Number(current_route[key]?.$numberDecimal) || 0;
//         console.log("current base price for ", car?.brand_and_model_name," price is ", base)
//         return base + base * (pricing_obj.platform_price / 100);
//       }
//       return 0;
//     },
//     [pricing_obj, current_route]
//   );


//   // pricing for full cabs function 
//   const getprice_for_fullcabs = useCallback(
//     (car) => {
//       if (!car || !pricing_obj || !current_route) return 0;

//       if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
//         const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
//         return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
//       }

//       if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
//         const key =
//           car.category === "Economy"
//             ? "full_cab_price_for_economy"
//             : car.category === "Luxury"
//               ? "full_cab_price_for_luxary"
//               : "full_cab_price_for_premium";
//         const base =
//           Number(current_route[key]?.$numberDecimal) * (1) || 0;
//                   console.log("current base price for ", car?.brand_and_model_name," price is ", base)

//         return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
//       }

//       return 0;
//     },
//     [pricing_obj, current_route]
//   );

//    const selectedDate = retrievedData?.date;
//    console.log("selected date  ===>", selectedDate)



// // Filter vehicles based on active tab
// // const filteredVehicles = useMemo(() => {
// //   if (!all_vehicle || !current_route || !selectedDate) return [];
// //   console.log("all vehicle ===>", all_vehicle)

// //   const selectedDateObj = new Date(selectedDate);

// //   // Check if vehicle is unavailable on the selected date
// //   const isUnavailable = (car) => {
// //     if (car.not_available) {
// //       const fromDate = new Date(car.not_available.from);
// //       const toDate = new Date(car.not_available.to);
// //       return selectedDateObj >= fromDate && selectedDateObj <= toDate;
// //     }
// //     return false;
// //   };

// //   if (activeTab === "shared") {
// //     return all_vehicle.filter((car) => {
// //       const sameRoute = car.route_id?._id === current_route._id;
// //       const categoryMatch = car.category === retrievedData?.seats;
// //       const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';

// //       return sameRoute && categoryMatch && sharedCab && !isUnavailable(car);
// //     });
// //   }

// //   // Full cabs
// //   return all_vehicle.filter((car) => {
// //     const sameRoute = car.route_id?._id === current_route._id;
// //     const assigned = tripdata.some(
// //       (trip) => trip.vehicleId === car._id && trip.route === current_route._id
// //     );
// //     const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
// //     const categoryMatch = car.category === retrievedData?.seats;

// //     return sameRoute && !assigned && fullCab && categoryMatch && !isUnavailable(car);
// //   });
// // }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);




// const filteredVehicles = useMemo(() => {
//   if (!all_vehicle || !current_route || !selectedDate) return [];

//   const selectedDateObj = new Date(selectedDate);

//   return all_vehicle
//     .filter((car) => {
//       const isSameRoute = car.route_id?._id === current_route._id;
//       const categoryMatch = car.category === retrievedData?.seats;

//       if (!isSameRoute || !categoryMatch) return false;

//       // Check if unavailable on selected date
//       const isUnavailable =
//         car.not_available &&
//         (() => {
//           const from = new Date(car.not_available.from);
//           const to = new Date(car.not_available.to);
//           return selectedDateObj >= from && selectedDateObj <= to;
//         })();

//       if (isUnavailable) return false;

//       // Validate by active tab
//       const cabFor = car.cab_available_for;
//       if (activeTab === "shared") {
//         return cabFor === "Shared-cab" || cabFor === "Both";
//       }
//       if (activeTab === "full") {
//         const isAssigned = tripdata.some(
//           (trip) => trip.vehicleId === car._id && trip.route === current_route._id
//         );
//         return (cabFor === "Full-Cab" || cabFor === "Both") && !isAssigned;
//       }

//       return false;
//     })
//     .flatMap((car) =>
//       (car.selected_schedules || []).map((schedule) => ({
//         ...car,
//         schedule_time: schedule.start,
//         schedule_id: schedule._id,
//       }))
//     );
// }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);





//   // Sort vehicles
//   const sortedVehicles = useMemo(() => {
//     const items = [...filteredVehicles];
//     if (!sortConfig.key) return items;
//     items.sort((a, b) => {
//       if (sortConfig.key === "price") {
//         const aP = getprice(a), bP = getprice(b);
//         return sortConfig.direction === "ascending" ? aP - bP : bP - aP;
//       }
//       if (sortConfig.key === "seats") {
//         const aS = a.seats.length, bS = b.seats.length;
//         return sortConfig.direction === "ascending" ? aS - bS : bS - aS;
//       }
//       if (sortConfig.key === "time") {
//         const tA = new Date(`1970-01-01T${a.time}`),
//           tB = new Date(`1970-01-01T${b.time}`);
//         return sortConfig.direction === "ascending" ? tA - tB : tB - tA;
//       }
//       return 0;
//     });
//     return items;
//   }, [filteredVehicles, sortConfig, getprice]);

//   const requestSort = (key) => {
//     const direction =
//       sortConfig.key === key && sortConfig.direction === "ascending"
//         ? "descending"
//         : "ascending";
//     setSortConfig({ key, direction });
//   };

//   const getSortIndicator = (key) =>
//     sortConfig.key !== key ? "⇵" : sortConfig.direction === "ascending" ? "▲" : "▼";

//   const convertTime = (kms) => {
//     if (!kms) return "0 hours";
//     const totalHours = (kms * 0.75) / 60;
//     const h = Math.floor(totalHours),
//       m = Math.round((totalHours - h) * 60);
//     return m === 0 ? `${h} ${h === 1 ? "hr" : "hrs"}` : `${h} ${h === 1 ? "hr" : "hrs"} ${m} min`;
//   };

//   const convertDateFormat = (d) => {
//     const dt = new Date(d);
//     return `${String(dt.getDate()).padStart(2, "0")}/${String(
//       dt.getMonth() + 1
//     ).padStart(2, "0")}/${dt.getFullYear()}`;
//   };

//   return (
//     <div className="flex flex-col lg:flex-row gap-4 px-0 lg:px-16 py-6 mt-28 mb-[5rem] font-lato">
//       <div className="w-full lg:w-3/4 bg-white bg-opacity-80 backdrop-blur-lg shadow-lg p-6 rounded-lg order-2 lg:order-1">
//         <div className="flex flex-wrap justify-center gap-4 mb-6">
//           <button
//             onClick={() => setActiveTab("shared")}
//             className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "shared"
//               ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
//               : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
//               }`}>
//             Shared Cabs
//           </button>
//           <button
//             onClick={() => setActiveTab("full")}
//             className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "full"
//               ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
//               : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
//               }`}>
//             Reserve Cabs
//           </button>
//         </div>
//         <div className="w-full flex flex-wrap justify-between bg-gray-100 shadow-md rounded-md p-3 text-center">
//           {[
//             { key: "seats", label: "Seats" },
//             { key: "price", label: "Fare" },
//             { key: "time", label: "Departure" },
//           ].map((header) => (
//             <div
//               key={header.key}
//               onClick={() => requestSort(header.key)}
//               className="flex-1 text-gray-700 font-semibold uppercase text-xs sm:text-sm cursor-pointer flex justify-center items-center hover:text-indigo-600 transition-all">
//               {header.label}
//               <span className="ml-1">{getSortIndicator(header.key)}</span>
//             </div>
//           ))}
//         </div>
//         {sortedVehicles.length ? (
//           sortedVehicles.map((car) => (
//             <div
//             key={`${car._id}`}
//               className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col md:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all">
//               <img
//                 src={car.picture_of_the_vehicle}
//                 alt={car.brand_name}
//                 className="w-full md:w-1/3 h-48 object-cover rounded-lg shadow-md"
//               />
//               <div className="flex flex-col md:flex-row justify-between w-full">
//                 <div className="flex-grow text-center md:text-left">
//                   <h3 className="text-lg sm:text-xl font-bold text-gray-800">
//                     {car.brand_name}
//                   </h3>
//                   <p className="text-gray-600 text-sm sm:text-base">
//                     {car.seats.length} Seater
//                   </p>
//                   <ul className="text-gray-500 text-xs sm:text-sm mt-2">
//                     {car.features?.map((feature, i) => (
//                       <li key={i}>• {feature}</li>
//                     ))}
//                   </ul>
//                 </div>
//                 <div className="flex flex-col items-center justify-center text-center w-full md:w-1/3">
//                   <h1 className="text-md sm:text-lg font-semibold text-indigo-600">
//                     {convertDateFormat(retrievedData.date)}
//                   </h1>
//                   <h4 className="text-gray-500 text-xs sm:text-sm">{car.time}</h4>
//                   <p className="bg-blue-200 text-blue-600 px-2 sm:px-3 py-1 mt-3 rounded-full font-semibold text-xs sm:text-sm">
//                     Duration: {convertTime(current_route?.no_of_kms)}
//                   </p>
//                 </div>
//                 <div className="flex flex-col items-center md:items-end justify-between text-center md:text-right mt-4 md:mt-0">
//                   <p className="text-xl sm:text-2xl font-bold text-green-500">
//                     ₹{activeTab === "shared" ? Math.round(getprice(car)) : Math.round(getprice_for_fullcabs(car))}/-
//                   </p>
//                   <Link to={activeTab === "shared" ? `/Seats/${car._id}` : `/fullcabbook/${car._id}`}>
//                     <button className="mt-4 bg-gradient-to-r from-blue-400 to-blue-500 text-white py-2 px-4 sm:px-5 rounded-md shadow-lg hover:from-green-500 hover:to-green-700 transition-all">
//                       {activeTab === "shared" ? "Select Seat" : "Book Full Cab"}
//                     </button>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="text-center py-8">
//             <p className="text-gray-600 text-lg font-medium">
//               No {activeTab === "shared" ? "shared" : "full"} vehicles available on this route
//             </p>
//             <p className="text-gray-500 text-sm mt-2">
//               Please try different filters or check back later
//             </p>
//           </div>
//         )}
//       </div>
//       <div className="w-full lg:w-1/4 rounded-lg p-4 order-1 lg:order-2">
//         <TripDetailsCard />
//       </div>
//     </div>
//   );
// };

// export default CarList;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import TripDetailsCard from "./TripDetailsCard";
import { fetchAllvehicle, vehicleSelector } from "../api/vehicles";
import { useDispatch, useSelector } from "react-redux";
import { fetchoneroute_details, routeSelector } from "../api/route";
import { fetchpricingmodal, pricingSelector } from "../api/pricesetting";
import axios from "axios";
import { KeyUri } from "../key";

const CarList = () => {
  // Memoize retrievedData so it doesn't change on every render
  const [retrievedData] = useState(() =>
    JSON.parse(localStorage.getItem("Selected Data"))
  );
  const { all_vehicle } = useSelector(vehicleSelector);
  const { current_route } = useSelector(routeSelector);
  const { currentPricing } = useSelector(pricingSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tripdata, set_trip_data] = useState([]);
  const [ride_date, set_ride_date] = useState();
  const [activeTab, setActiveTab] = useState("shared");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
  const [pricing_obj, setPricing_obj] = useState({});

  // Run once on mount
  useEffect(() => {
    if (!retrievedData) return;
    dispatch(fetchAllvehicle());
    dispatch(fetchoneroute_details(retrievedData));
    dispatch(fetchpricingmodal());
    const formattedDate = new Date(retrievedData?.date).toISOString();
    set_ride_date(formattedDate);
  }, [dispatch, retrievedData]);

  // Fetch trip data when ride_date changes
  useEffect(() => {
    if (!ride_date) return;
    const fetchTrip = async () => {
      try {
        const response = await axios.post(
          `${KeyUri.BACKEND_URI}/get-full-cabs`,
          { rideDate: ride_date }
        );
        set_trip_data(response.data.details || []);
      } catch (error) {
        console.error("Error fetching trip:", error.response?.data || error.message);
      }
    };
    fetchTrip();
  }, [ride_date]);

  // Update pricing object when currentPricing changes
  useEffect(() => {
    setPricing_obj(currentPricing?.[0] || {});
  }, [currentPricing]);

  // Memoize getprice to avoid recreation
  const getprice = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;
      if (pricing_obj.pricing_model === "Driver Fixed") {
        const perSeat =
          Number(car.price_per_trip?.$numberDecimal) / (car.capacity - 1);
        return perSeat + perSeat * (pricing_obj.platform_price / 100);
      }
      if (pricing_obj.pricing_model === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "price_for_economy"
            : car.category === "Luxury"
              ? "price_for_luxary"
              : "price_for_premium";
        const base = Number(current_route[key]?.$numberDecimal) || 0;
        return base + base * (pricing_obj.platform_price / 100);
      }
      return 0;
    },
    [pricing_obj, current_route]
  );

  // pricing for full cabs function 
  const getprice_for_fullcabs = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;

      if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
        const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
        return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
      }

      if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "full_cab_price_for_economy"
            : car.category === "Luxury"
              ? "full_cab_price_for_luxary"
              : "full_cab_price_for_premium";
        const base =
          Number(current_route[key]?.$numberDecimal) * (1) || 0;
        return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
      }

      return 0;
    },
    [pricing_obj, current_route]
  );

  const selectedDate = retrievedData?.date;

  // Filter vehicles based on active tab and expand by schedule
  const filteredVehicles = useMemo(() => {
    if (!all_vehicle || !current_route || !selectedDate) return [];

    const selectedDateObj = new Date(selectedDate);

    // Base vehicle filtering
    const baseFiltered = all_vehicle.filter(car => {
      // Check if vehicle is unavailable
      const isUnavailable = () => {
        if (car.not_available) {
          const fromDate = new Date(car.not_available.from);
          const toDate = new Date(car.not_available.to);
          return selectedDateObj >= fromDate && selectedDateObj <= toDate;
        }
        return false;
      };

      if (isUnavailable()) return false;

      const sameRoute = Array.isArray(car?.route_id) && (
        car.route_id.includes(current_route?._id) ||
        car.route_id.some(r => r?._id === current_route?._id)
      );
      const categoryMatch = car.category === retrievedData?.seats;

      if (activeTab === "shared") {
        const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
        return sameRoute && categoryMatch && sharedCab;
      } else {
        const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
        const assigned = tripdata.some(
          trip => trip.vehicleId === car._id && trip.route === current_route._id
        );
        return sameRoute && !assigned && fullCab && categoryMatch;
      }
    });

    // Expand vehicles by their schedules
    return baseFiltered.flatMap(car => {
      if (
        Array.isArray(car.selected_schedules) &&
        car.selected_schedules.length > 0
      ) {
        return car.selected_schedules
          .filter(routeSchedule => {
            const route = routeSchedule?.route;
            // Handle both string and populated object
            return (
              route === current_route._id ||
              route?._id === current_route._id
            );
          })
          .flatMap(routeSchedule => {
            const routeId = routeSchedule?.route?._id || routeSchedule?.route;
    
            // Case 1: Populated schedules (objects with start time)
            if (
              Array.isArray(routeSchedule.schedules) &&
              typeof routeSchedule.schedules[0] === 'object'
            ) {
              return routeSchedule.schedules.map(schedule => ({
                ...car,
                route_id: routeId,
                schedule_time: schedule.start,
                schedule_id: schedule._id
              }));
            }
    
            // Case 2: Unpopulated schedules (IDs only)
            return routeSchedule.schedules.map(scheduleId => ({
              ...car,
              route_id: routeId,
              schedule_time: null, // No start time since it's unpopulated
              schedule_id: scheduleId
            }));
          });
      }
    
      // Fallback: No selected_schedules
      return [{
        ...car,
        schedule_time: car.time,
        schedule_id: null
      }];
    });
    
  }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);

  // Sort vehicles
  const sortedVehicles = useMemo(() => {
    const items = [...filteredVehicles];
    if (!sortConfig.key) return items;

    items.sort((a, b) => {
      if (sortConfig.key === "price") {
        const aP = activeTab === "shared" ? getprice(a) : getprice_for_fullcabs(a);
        const bP = activeTab === "shared" ? getprice(b) : getprice_for_fullcabs(b);
        return sortConfig.direction === "ascending" ? aP - bP : bP - aP;
      }
      if (sortConfig.key === "seats") {
        const aS = a.seats.length, bS = b.seats.length;
        return sortConfig.direction === "ascending" ? aS - bS : bS - aS;
      }
      if (sortConfig.key === "time") {
        const tA = new Date(`1970-01-01T${a.schedule_time}`);
        const tB = new Date(`1970-01-01T${b.schedule_time}`);
        return sortConfig.direction === "ascending" ? tA - tB : tB - tA;
      }
      return 0;
    });
    return items;
  }, [filteredVehicles, sortConfig, getprice, getprice_for_fullcabs, activeTab]);

  const requestSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "ascending"
        ? "descending"
        : "ascending";
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) =>
    sortConfig.key !== key ? "⇵" : sortConfig.direction === "ascending" ? "▲" : "▼";

  const convertTime = (kms) => {
    if (!kms) return "0 hours";
    const totalHours = (kms * 0.75) / 60;
    const h = Math.floor(totalHours),
      m = Math.round((totalHours - h) * 60);
    return m === 0 ? `${h} ${h === 1 ? "hr" : "hrs"}` : `${h} ${h === 1 ? "hr" : "hrs"} ${m} min`;
  };

  const convertDateFormat = (d) => {
    const dt = new Date(d);
    return `${String(dt.getDate()).padStart(2, "0")}/${String(
      dt.getMonth() + 1
    ).padStart(2, "0")}/${dt.getFullYear()}`;
  };

  return (
    <div className="flex flex-col lg:flex-row gap-4 px-0 lg:px-16 py-6 mt-28 mb-[5rem] font-lato">
      <div className="w-full lg:w-3/4 bg-white bg-opacity-80 backdrop-blur-lg shadow-lg p-6 rounded-lg order-2 lg:order-1">
        <div className="flex flex-wrap justify-center gap-4 mb-6">
          <button
            onClick={() => setActiveTab("shared")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "shared"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Shared Cabs
          </button>
          <button
            onClick={() => setActiveTab("full")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "full"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Reserve Cabs
          </button>
        </div>
        <div className="w-full flex flex-wrap justify-between bg-gray-100 shadow-md rounded-md p-3 text-center">
          {[
            { key: "seats", label: "Seats" },
            { key: "price", label: "Fare" },
            { key: "time", label: "Departure" },
          ].map((header) => (
            <div
              key={header.key}
              onClick={() => requestSort(header.key)}
              className="flex-1 text-gray-700 font-semibold uppercase text-xs sm:text-sm cursor-pointer flex justify-center items-center hover:text-indigo-600 transition-all">
              {header.label}
              <span className="ml-1">{getSortIndicator(header.key)}</span>
            </div>
          ))}
        </div>
        {sortedVehicles.length ? (
          sortedVehicles.map((car) => (
            <div
              key={`${car._id}-${car.schedule_id || "default"}`}
              className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col md:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all">
              <img
                src={car.picture_of_the_vehicle}
                alt={`${car?.brand_name ?? ''} ${car?.model_name ?? ''}`}

                className="w-full md:w-1/3 h-48 object-cover rounded-lg shadow-md"
              />
              <div className="flex flex-col md:flex-row justify-between w-full">
                <div className="flex-grow text-center md:text-left">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                    {car.brand_name + ' ' + car.model_name}

                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base">
                    {car.seats.length} Seater
                  </p>
                  <ul className="text-gray-500 text-xs sm:text-sm mt-2">
                    {car.features?.map((feature, i) => (
                      <li key={i}>• {feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-col items-center justify-center text-center w-full md:w-1/3">
                  <h1 className="text-md sm:text-lg font-semibold text-indigo-600">
                    {convertDateFormat(retrievedData.date)}
                  </h1>
                  <h4 className="text-gray-500 text-xs sm:text-sm">
                    {car.schedule_time}time 
                  </h4>
                  <p className="bg-blue-200 text-blue-600 px-2 sm:px-3 py-1 mt-3 rounded-full font-semibold text-xs sm:text-sm">
                    Duration: {current_route?.duration || "Not specified"}
                  </p>
                </div>
                <div className="flex flex-col items-center md:items-end justify-between text-center md:text-right mt-4 md:mt-0">
                  <p className="text-xl sm:text-2xl font-bold text-green-500">
                    ₹{activeTab === "shared" ? Math.round(getprice(car)) : Math.round(getprice_for_fullcabs(car))}/-
                  </p>
                  <button
                    onClick={() => {
                      try {
                        const existingBooking = JSON.parse(localStorage.getItem("Selected Data"));

                        let time = car.schedule_time;
                        if (!time) throw new Error("Schedule time is missing");
                        if (time.length === 5) time += ":00"; // make sure it's in HH:mm:ss

                        // Step 1: Strip time from existing date (keep only YYYY-MM-DD)
                        const rawDate = existingBooking.date?.split("T")[0]; // "2025-07-03"

                        // Step 2: Combine date + new time
                        const fullDateTime = `${rawDate}T${time}`;

                        // Step 3: Validate and convert to ISO string
                        const fullDateObj = new Date(fullDateTime);
                        if (isNaN(fullDateObj.getTime())) {
                          alert("Invalid date or time format");
                          return;
                        }

                        const updatedBooking = {
                          ...existingBooking,
                          date: fullDateObj.toISOString(),
                        };

                        localStorage.setItem("Selected Data", JSON.stringify(updatedBooking));

                        const path = activeTab === "shared" ? `/Seats/${car._id}` : `/fullcabbook/${car._id}`;
                        navigate(path);
                      } catch (err) {
                        console.error("Booking error:", err);
                        alert("Something went wrong while booking. Please try again.");
                      }
                    }}
                    className="mt-4 bg-gradient-to-r from-blue-400 to-blue-500 text-white py-2 px-4 sm:px-5 rounded-md shadow-lg hover:from-green-500 hover:to-green-700 transition-all"
                  >
                    {activeTab === "shared" ? "Select Seat" : "Book Full Cab"}
                  </button>


                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-600 text-lg font-medium">
              No {activeTab === "shared" ? "shared" : "full"} vehicles available on this route
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Please try different filters or check back later
            </p>
          </div>
        )}
      </div>
      <div className="w-full lg:w-1/4 rounded-lg p-4 order-1 lg:order-2">
        <TripDetailsCard />
      </div>
    </div>
  );
};

export default CarList;